<div class="fpx-form-control">
    <div class="fpx-field-content">
        <mat-slide-toggle class="fpx-toggle"
            [formControl]="formControl"
            [labelPosition]="labelPosition" >
            {{label}}
        </mat-slide-toggle>
    </div>
  </div>

  